// extracted by mini-css-extract-plugin
export default {"root":"Autocomplete_root__Gw1cV","rootDisabled":"Autocomplete_rootDisabled__D-S+D"};